import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux/es/exports'
import { useHistory } from 'react-router-dom'

import packageJson from '../../../package.json'
import { getNewPassword, login, updatePassword } from '../../api/auth/auth.api'
import returnIcon from '../../imgs/next.png'
import { getRatesAction } from '../../store/packageSlice'
import { setLoggedUserAction } from '../../store/userSlice'
import TheFooter from './TheFooter'

const initialFormState = {
  username: '',
  password: '',
  passwordConfirmation: '',
  authCode: '',
  phone: '',
  name: '',
  family_name: '',
  forgotPasswordConfirmationCode: '',
  forgotPasswordNewPassword: '',
  formType: 'signIn',
}

export default function SignInComponent() {
  const history = useHistory()
  const dispatch = useDispatch()
  const [formState, updateFormState] = useState(initialFormState)
  const [isLoadingSignIn, setIsLoadingSignIn] = useState(false)
  const [show, setShow] = useState(false)
  const [textForAlert, setTextForAlert] = useState('')
  const { formType } = formState
  const { loggedUser } = useSelector(state => state.user)
  const [showInactivityModal, setShowInactivityModal] = useState(false)

  useEffect(() => {
    document.title = 'התחברות לאזור האישי | ShipTanbul'

    const logoutReason = localStorage.getItem('logout-reason')
    if (logoutReason === 'inactivity') {
      setShowInactivityModal(true)
      localStorage.removeItem('logout-reason')
    }
  }, [])

  const onChange = e => {
    e.persist()
    updateFormState(() => ({ ...formState, [e.target.name]: e.target.value }))
  }

  const forgotPasswordHandler = () => {
    updateFormState(() => ({ ...formState, formType: 'forgotPassword' }))
  }

  const forgotPassword = async () => {
    try {
      setIsLoadingSignIn(true)
      const { username } = formState
      await getNewPassword(username)

      updateFormState(() => ({
        ...formState,
        formType: 'forgotPasswordConfirmation',
      }))

      setIsLoadingSignIn(false)
    } catch (error) {
      console.log('forgotPassword - error', error)
      setTextForAlert('משתמש לא נמצא')
      setShow(true)
      setIsLoadingSignIn(false)
    }
  }

  const getTextError = error => {
    if (error == 0) return 'שגיאה! הסיסמאות שהכנסת לא זהות'
    if (error.response.data.error.code == 'CodeMismatchException') return 'שגיאה! קוד האימות שגוי'
    else return 'שגיאה! אנא בדוק שכל הנתונים נכונים ונסה שנית'
  }

  const forgotPasswordConfirmation = async () => {
    try {
      setIsLoadingSignIn(true)
      if (formState.forgotPasswordNewPassword !== formState.forgotPasswordNewPassword2) throw '0'
      const { username, forgotPasswordNewPassword, forgotPasswordConfirmationCode } = formState
      await updatePassword(username, forgotPasswordConfirmationCode, forgotPasswordNewPassword)

      setTextForAlert('סיסמתך החדשה עודכנה')
      setShow(true)
      updateFormState(() => ({ ...formState, formType: 'signIn' }))
      setIsLoadingSignIn(false)
    } catch (error) {
      console.log('forgotPasswordConfirmation - error', error)
      setTextForAlert(error.response?.data?.msg || getTextError(error))
      setShow(true)
      setIsLoadingSignIn(false)
    }
  }

  const handleKeypress = e => {
    if (e.key === 'Enter') {
      signIn()
    }
  }

  const signIn = async () => {
    try {
      setIsLoadingSignIn(true)
      const { username, password } = formState

      const signinPromisResult = await login(username, password, packageJson.version)

      //update permissions
      let updatedPermission = { ...loggedUser.permissions }
      if (signinPromisResult.data.data['cognito:groups']) {
        signinPromisResult.data.data['cognito:groups'].forEach(group => {
          updatedPermission = { ...updatedPermission, [group]: true }
        })
      }
      const user = {
        UserAttributes: signinPromisResult.data.data,
        Username: signinPromisResult.data.data.sub,
        groups: {
          Groups: signinPromisResult.data.data['cognito:groups'] ? signinPromisResult.data.data['cognito:groups'] : [],
        },
        permissions: updatedPermission,
      }

      //update redux & local storage
      dispatch(setLoggedUserAction(user))
      dispatch(getRatesAction())
      localStorage.setItem('cognito-tokens', JSON.stringify(signinPromisResult.data.token))

      setIsLoadingSignIn(false)
      if (history.location.pathname == '/' || history.location.pathname == '/welcome') history.push('/personal-info')
      else history.push(history.location.pathname)
    } catch (error) {
      setIsLoadingSignIn(false)
      // Use the new error handling system
      if (error.msg) {
        setTextForAlert(error.msg)
      } else {
        setTextForAlert('.בעיה בחיבור לרשת, אנא נסה שנית')
      }
      setShow(true)
    }
  }

  return (
    <div className='signin-cont'>
      <Container className='containerForm'>
        <Modal show={show} onHide={() => setShow(false)}>
          <Modal.Header style={{ textAlign: 'right' }}>
            <div style={{ width: '100%' }}>
              <Modal.Title style={{ direction: 'rtl' }}>שים לב!</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>{textForAlert}</Modal.Body>
          <Modal.Footer style={{ direction: 'rtl' }}>
            <Button variant='danger' onClick={() => setShow(false)}>
              סגור
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showInactivityModal} onHide={() => setShowInactivityModal(false)}>
          <Modal.Header style={{ textAlign: 'right' }}>
            <div style={{ width: '100%' }}>
              <Modal.Title style={{ direction: 'rtl' }}>התנתקות אוטומטית</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body style={{ direction: 'rtl' }}>התנתקת מהמערכת עקב חוסר פעילות. אנא התחבר מחדש.</Modal.Body>
          <Modal.Footer style={{ direction: 'rtl' }}>
            <Button variant='primary' onClick={() => setShowInactivityModal(false)}>
              הבנתי
            </Button>
          </Modal.Footer>
        </Modal>

        {formType === 'signIn' && (
          <Row className='loginForm rtlText'>
            <Col className='loginFormCol rtlText'>
              <h2 style={{ textAlign: 'center', fontWeight: 'bold' }}> התחברות</h2>
              <Form>
                <Form.Group>
                  <Row style={{ padding: '1rem', paddingBottom: '0' }}>אימייל</Row>
                  <Form.Control onChange={onChange} name='username' type='email' placeholder='אימייל' />
                </Form.Group>

                <Form.Group>
                  <Row style={{ padding: '1rem', paddingBottom: '0' }}>
                    <span>סיסמא </span>
                  </Row>

                  <Form.Control onChange={onChange} onKeyPress={handleKeypress} name='password' type='password' placeholder='סיסמא' />

                  <Row
                    style={{
                      marginRight: '69%',
                      fontSize: 'smaller',
                      padding: '0.3rem',
                      paddingTop: '0',
                    }}
                  >
                    <u style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={forgotPasswordHandler}>
                      שכחתי סיסמא
                    </u>
                  </Row>
                </Form.Group>

                <Form.Group>
                  <div
                    style={{
                      textAlign: 'center',
                      marginBottom: '5px',
                      display: 'flex',
                      justifyContent: 'center',
                      height: '42px',
                    }}
                  >
                    {isLoadingSignIn ? (
                      <Spinner animation='border' variant='primary' />
                    ) : (
                      <Button block disabled={isLoadingSignIn && 'true'} onClick={signIn} variant='primary' style={{ minWidth: '190px' }}>
                        התחבר
                      </Button>
                    )}
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                    <a href='http://www.shiptanbul.com/start-here'>
                      <Button variant='secondary' style={{ minWidth: '190px' }}>
                        אני רוצה להירשם
                      </Button>
                    </a>
                  </div>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        )}

        {formType === 'forgotPassword' && (
          <div className='rtlText' style={{ marginTop: '10px' }}>
            <div className='signin-return-cont' onClick={() => updateFormState(() => ({ ...formState, formType: 'signIn' }))}>
              <img src={returnIcon} />
              <span>חזרה</span>
            </div>
            <Form.Control onChange={onChange} name='username' type='email' placeholder='כתובת המייל שאיתה נרשמת' />
            <Form.Text className='text-muted'>
              <Alert variant='light'>
                לכתובת המייל הזו ישלח קוד סודי לשינוי הסיסמא.
                <br />
                לכן יש לוודא שהכתובת שהזנת תקינה ותואמת לכתובת שאיתה נרשמת לאתר.
              </Alert>
            </Form.Text>
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              {isLoadingSignIn ? (
                <Spinner animation='border' variant='primary' />
              ) : (
                <Button onClick={forgotPassword} variant='primary' style={{ marginBottom: '10px' }}>
                  שלחו אלי קוד
                </Button>
              )}
            </div>
          </div>
        )}

        {formType === 'forgotPasswordConfirmation' && (
          <Row className='loginForm rtlText'>
            <Col className='loginFormCol rtlText'>
              <div className='signin-return-cont' onClick={() => updateFormState(() => ({ ...formState, formType: 'signIn' }))}>
                <img src={returnIcon} />
                <span>חזרה</span>
              </div>
              <Form>
                <Form.Group>
                  <Form.Label>אימייל</Form.Label>
                  <Form.Control onChange={onChange} name='username' type='email' placeholder='אימייל' />
                  <Form.Text className='text-muted'>יש להזין את המייל שאליו נשלח קוד האימות</Form.Text>
                </Form.Group>

                <Form.Group>
                  <Form.Label> יש להזין כאן את הקוד שהתקבל במייל</Form.Label>
                  <Form.Control
                    onChange={onChange}
                    name='forgotPasswordConfirmationCode'
                    type='text'
                    placeholder='קוד האימות שהתקבל במייל'
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>סיסמא חדשה</Form.Label>
                  <Form.Control onChange={onChange} name='forgotPasswordNewPassword' type='password' placeholder='סיסמא חדשה' />
                  <Form.Text className='text-muted'>על הסיסמא לכלול: לפחות 8 תווים ואות באנגלית</Form.Text>
                </Form.Group>

                <Form.Group>
                  <Form.Label>הכנס שוב סיסמא חדשה</Form.Label>
                  <Form.Control onChange={onChange} name='forgotPasswordNewPassword2' type='password' placeholder='סיסמא חדשה' />
                  <Form.Text className='text-muted'>על הסיסמא לכלול: לפחות 8 תווים ואות באנגלית</Form.Text>
                </Form.Group>

                <Form.Group style={{ textAlign: 'center' }}>
                  {!isLoadingSignIn ? (
                    <Button onClick={forgotPasswordConfirmation} variant='primary'>
                      שנה סיסמא
                    </Button>
                  ) : (
                    <Spinner animation='border' variant='primary' />
                  )}
                </Form.Group>
              </Form>
            </Col>
          </Row>
        )}
      </Container>
      <section className='signin-footer-cont'>
        <TheFooter />
      </section>
    </div>
  )
}
